var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 8.1875L18 6.625V4.1875C18 4.09375 17.9062 4 17.8125 4H17.1875C17.0625 4 17 4.09375 17 4.1875V5.8125L12.625 2.25C12.4688 2.125 12.1875 2.03125 12 2.03125C11.7812 2.03125 11.5 2.125 11.3438 2.25L4.09375 8.1875C4.03125 8.21875 4 8.3125 4 8.375C4 8.40625 4 8.5 4.03125 8.53125L4.34375 8.90625C4.40625 8.96875 4.5 9 4.5625 9C4.59375 9 4.65625 8.96875 4.71875 8.9375L6 7.90625V15.5C6 15.7812 6.21875 16 6.5 16H10.5C10.75 16 11 15.7812 11 15.5V11.5H13V15.5C13 15.7812 13.2188 16 13.5 16H17.5C17.75 16 18 15.7812 18 15.5V7.90625L19.25 8.9375C19.3125 8.96875 19.375 9 19.4062 9C19.5 9 19.5625 8.96875 19.625 8.90625L19.9375 8.53125C19.9688 8.5 19.9688 8.40625 19.9688 8.375C19.9688 8.3125 19.9375 8.21875 19.9062 8.1875ZM16.9688 15L13.9688 15.0312V11C13.9688 10.75 13.75 10.5 13.5 10.5H10.5H10.4688C10.2188 10.5 9.96875 10.7188 9.96875 11V15H7V7.09375L12 3L17 7.09375L16.9688 15Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c7bc45ab.svg";
export { ForwardRef as ReactComponent };